import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/index'

import 'amfe-flexible'
import ElementUI from 'element-ui';
import "./utils/vant"
import "./assets/css/vant/van.scss"
import './assets/css/common.css'
import './assets/css/element/index.scss'
import './assets/font/iconfont.css'
import 'element-ui/lib/theme-chalk/index.css';
import 'normalize.css';
import "./utils/rem"
import VueAwesomeSwiper from 'vue-awesome-swiper'
import MetaInfo from 'vue-meta-info'
import VueClipboard from 'vue-clipboard2'
import FastClick from 'fastclick';

import {
  get,
  indexPost,
  userPost,
  myBasePost,
  downloadsPost
} from './utils/request'
import config from './utils/config'

Vue.prototype.$get = get; //请求接口get
Vue.prototype.$indexPost = indexPost; //请求接口indexPost
Vue.prototype.$userPost = userPost; //请求接口userPost
Vue.prototype.$myBasePost = myBasePost;
Vue.prototype.$downloadsPost = downloadsPost; //请求接口downloadsPost
Vue.prototype.config = config; //
Vue.use(VueAwesomeSwiper, /* { 全局组件的默认选项 } */ )
Vue.use(MetaInfo)
Vue.use(VueClipboard)
Vue.config.productionTip = false
Vue.use(ElementUI);

// vue2的用法
// FastClick.attach(document.body)


new Vue({
  router,
  store,
  render: h => h(App),
  //添加到这里,这里的render-event和vue.config.js里面的renderAfterDocumentEvent配置名称一致
  mounted() {
    setTimeout(() => {
      document.dispatchEvent(new Event('render-event'))
    }, 10000)
  }

}).$mount('#app')